import { UntypedFormGroup } from "@angular/forms";
import { Injectable } from "@angular/core";

@Injectable()
export class PasswordValidationService {
  static validate(registrationFormGroup: UntypedFormGroup) {
    const newPassword = registrationFormGroup.controls.newpassword.value;
    const repeatPassword = registrationFormGroup.controls.repeatpassword.value;

    if (repeatPassword.length <= 0) {
      return null;
    }

    if (repeatPassword !== newPassword) {
      return {
        doesMatchPassword: true
      };
    }

    return null;
  }
}
